export const contactFields = `
  id
  anonymous
  avatarUri
  contactable
  crmId
  email
  firstName
  jobTitle
  lastName
  linkedin
  phoneNumber
  mobilePhone
  updatedAt
  company {
    id
    name
  }
`;

/**
 * Use cases:
 *  - Create room
 *  - Update room
 */
export const roomEditContactFields = `
  id
  anonymous
  crmId
  email
  firstName
  jobTitle
  lastName
  linkedin
  mobilePhone
  company {
    name
  }
`;

/**
 * Use cases:
 *  - Send room updated email notification
 *  - Send room SMS notification
 */
export const roomNotificationsContactFields = `
  id
  anonymous
  crmId
  email
  firstName
  lastName
  mobilePhone
  phoneNumber
`;
